import { Outlet } from 'react-router';

const Reports = () => {
  return <Outlet />;
};

export default Reports;
